interface IndexedItem {
    index: number
}
export function indexUp<T extends IndexedItem>(array: T[], index: number): T[] {

    if (!array?.length) return array;
    if (index <= 0 || index > array.length) return array;

    const newArray = array.map(item => {
        if (item.index === index) {
            return { ...item, index: index - 1 };
        }
        if (item.index === index - 1) {
            return { ...item, index: index };
        }
        return item;
    });

    return newArray.sort((a, b) => a.index - b.index);
}
export function indexDown<T extends IndexedItem>(array: T[], index: number): T[] {
    if (!array?.length) return array;
    if (index < 0 || index >= array.length) return array;

    const newArray = array.map(item => {
        if (item.index === index) {
            return { ...item, index: index + 1 };
        }
        if (item.index === index + 1) {
            return { ...item, index: index };
        }
        return item;
    });

    return newArray.sort((a, b) => a.index - b.index);
}